import { ComparisonOperator, ORDER_SIDE } from '@/services/enums';

export const fixedRuleOptions = [
  {
    id: 'rsi14_gt_70_sell',
    label: 'RSI(14) > 70 超买',
    signal: {
      type: ORDER_SIDE.SELL,
      description: 'RSI(14) > 70 超买',
      conditions: [
        {
          field: 'rsi14',
          operator: '>' as ComparisonOperator,
          value: 70,
        },
      ],
      triggered: false,
    },
  },
  {
    id: 'rsi14_lt_30_buy',
    label: 'RSI(14) < 30 超卖',
    signal: {
      type: ORDER_SIDE.BUY,
      description: 'RSI(14) < 30 超卖',
      conditions: [
        {
          field: 'rsi14',
          operator: '<' as ComparisonOperator,
          value: 30,
        },
      ],
      triggered: false,
    },
  },
];
